import { useEffect } from 'react';
import { useBrowserStore } from '@/stores/browserStore';
import { ConnectionPanel } from '@/components/browser/ConnectionPanel';
import { ActivityLog } from '@/components/browser/ActivityLog';
import { PageAnalysis } from '@/components/browser/PageAnalysis';
import { ScriptRecorder } from '@/components/browser/ScriptRecorder';
import { ScreenshotPreview } from '@/components/browser/ScreenshotPreview';

export function BrowserPage() {
  const { extensionConnected, startPolling, stopPolling } = useBrowserStore();

  useEffect(() => {
    startPolling();
    return () => stopPolling();
  }, [startPolling, stopPolling]);

  return (
    <div className="flex h-screen flex-col bg-background text-foreground">
      <main className="flex-1 overflow-auto">
        <div className="mx-auto max-w-3xl p-6 space-y-4">
          <div className="flex items-center justify-between">
            <h1 className="text-lg font-medium text-foreground">Browser Control</h1>
          </div>

          {/* Connection Panel (always shown) */}
          <ConnectionPanel />

          {/* Only show operational panels when connected */}
          {extensionConnected && (
            <>
              <ScriptRecorder />
              <ScreenshotPreview />
              <ActivityLog />
              <PageAnalysis />
            </>
          )}
        </div>
      </main>
    </div>
  );
}
